export default __webpack_public_path__ + "static/media/category-wellbeing.5cda6df7.jpg";